var React = require('react');

function ShareFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M52 26.6589C52 12.2117 40.3594 0.5 26 0.5C11.6406 0.5 0 12.2117 0 26.6589C0 39.7154 9.50777 50.5376 21.9375 52.5V34.2204H15.3359V26.6589H21.9375V20.8958C21.9375 14.3397 25.8192 10.7183 31.7581 10.7183C34.6018 10.7183 37.5781 11.2292 37.5781 11.2292V17.6668H34.2997C31.07 17.6668 30.0625 19.6834 30.0625 21.7541V26.6589H37.2734L36.1207 34.2204H30.0625V52.5C42.4922 50.5376 52 39.7154 52 26.6589Z","fill":"#131416"}));
}

ShareFacebookInline.defaultProps = {"width":"52","height":"53","viewBox":"0 0 52 53","fill":"none","role":"img","aria-label":"Facebook"};

module.exports = ShareFacebookInline;

ShareFacebookInline.default = ShareFacebookInline;
